import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import {mask} from 'vue-the-mask'
import Forms from '@/components/forms/Forms'
import Tables from '@/components/forms/Tables'
import TableColumn from '@/components/forms/TableColumn'
import { JWTService } from '@/shared/services/jwt'
// import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'
const ipify = require('ipify2')

export default {
  name: 'actionForms',
  // mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles,
      permissions: null,
      data: null,
      form: null,
      objList: null,
      error: null,
      polling: null,
      latitude: null,
      longitude: null,
      ip: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  directives: {mask},
  components: {
    Forms,
    Tables,
    TableColumn
  },
  computed: {
    FieldSizeTip: function () {
      var result = ''
      if (this.form.hasOwnProperty('description')) {
        result = this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
      }
      return result
    }
  },
  created () {
    this.getLocation()
    this.getIp()
  },
  async mounted () {
    Tools.MinimizedSidebar()
    this.onClear()
    this.onLoad()
    this.permissions = JWTService.GetRoles()
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onSave () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        // Set default data
        // this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        // this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data.hasOwnProperty('tenantID')) {
          this.data.tenantID = JWTService.GetTokenPayload().tenantID
        }

        if (this.data) {
          if (this.data.id && this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.data.status = parseInt(this.data.status)
            this.onUpdate()
          } else {
            this.data.id = null // '00000000-0000-0000-0000-000000000000'
            this.data.status = 1
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onSearch () {
      console.log('Warning: Override method in your view implementation onSearch()')
    },
    onLoad () {
      console.log('Warning: Override method in your view implementation onLoad()')
    },
    onCreate () {
      console.log('Warning: Override method in your view implementation onCreate()')
    },
    onUpdate () {
      console.log('Warning: Override method in your view implementation onUpdate()')
    },
    onChange (obj) {
      for (var key in this.data) {
        if (obj.hasOwnProperty(key)) {
          this.data[key] = obj[key]
        }
      }
      if (this.data.status === 1) {
        this.data.status = 0
      } else {
        this.data.status = 1
      }
      this.onUpdate()
    },
    onResultObj (response) {
      if (response.data.code >= 0) {
        return response.data.data
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
        return null
      }
      // loading.pop()
    },
    onResultSimple (response) {
      this.onResult(response, true, true)
    },
    onResult (response, IsNotLoad, IsNotClear) {
      if (response.status >= 0) {
        if (!IsNotClear) {
          this.onClear()
        }
        toast.success(this.$lang.Common.Alerts.Success)
        // this.$refs.alert.ShowSuccess()
        if (!IsNotLoad) {
          this.onLoad()
        }
      } else {
        // this.$refs.alert.ShowError
        toast.error(this.$lang.Common.Alerts.Error)()
      }
      loading.pop()
    },
    onResultGrid (response, tableGridRef) {
      if (response.status === 200) {
        this.objList = response.data.content
        if (tableGridRef) {
          tableGridRef.LoadAllByData(response)
        } else {
          this.$refs.tableGrid.LoadAllByData(response)
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()
    },
    onResultGridWithNoResponse (data, tableGridRef) {
      if (data) {
        this.objList = data
        if (tableGridRef) {
          tableGridRef.loadAllByDataWithNoResponse(data)
        } else {
          this.$refs.tableGrid.loadAllByDataWithNoResponse(data)
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()
    },
    onStartTotalGrid (tableGridRef, total) {
      tableGridRef.LoadStartTotalGrid(total)
    },
    onException (err) {
      if (err.message === 'Unauthorized' || err.message === 'ExpiredToken' || err.message === 'Cannot read properties of undefined (reading \'status\')') {
        toast.error(this.$lang.Common.SessionEnded)
      } else {
        // O interceptor do axios retorna error.response diretamente
        // Então err pode ser o response ou o error completo
        // Verifica ambas as possibilidades
        let errorData = null
        if (err.data && err.data.errors) {
          // err já é o response (caso do interceptor)
          errorData = err.data.errors
        } else if (err.response && err.response.data && err.response.data.errors) {
          // err é o error completo (caso sem interceptor)
          errorData = err.response.data.errors
        }

        if (errorData && Array.isArray(errorData) && errorData.length > 0) {
          const errorMessage = errorData[0].message
          if (errorMessage) {
            toast.error(errorMessage)
          } else {
            toast.error(this.$lang.Common.MicroserviceUnavailable)
          }
        } else {
          toast.error(this.$lang.Common.MicroserviceUnavailable)
        }
      }
      loading.pop()
    },
    handleDuplicateEntryException (error) {
      loading.close()

      console.warn(
        'Erro de duplicidade:',
        error && error.response && error.response.data && error.response.data.message
      )

      toast.error('<strong>Atenção: </strong> Já existe uma Lista Inteligente com esse nome.')
    },
    onExceptionWithErrorMessage (err) {
      loading.pop()

      const defaultMessage = this.$lang.Common.DefaultErrorMessage

      console.log(err)

      if (err && err.data) {
        const { data } = err

        if (Array.isArray(data.errors) && data.errors.length > 0 && data.errors[0].message) {
          toast.error(`${defaultMessage} ${data.errors[0].message}`)
        } else if (typeof data === 'string') {
          toast.error(`${defaultMessage} ${data}`)
        }
      } else {
        this.onException(err)
      }
    },
    advancedOnException (error) {
      loading.pop()

      if (error.message === 'Unauthorized' || error.message === 'ExpiredToken' || error.message === 'Cannot read properties of undefined (reading \'status\')') {
        toast.error(this.$lang.Common.SessionEnded)
        return
      }
      if (error.data) {
        if (error.data.errors) {
          if (error.data.errors[0].message === 'could not execute statement; SQL [n/a]; constraint [pessoa.uk_document]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement') {
            toast.error('Documento já cadastrado')
            return
          }
          if (error.data.errors[0].identification === 'Usuário já existe') {
            toast.error('Nome de Usuário já cadastrado')
            return
          }
          if (error.data.errors[0].message === 'Senha inválida') {
            toast.error('Senha inválida')
            return
          }
          if (error.data.errors[0].identification) {
            toast.error(error.data.errors[0].identification)
            return
          }
          if (error.data.errors[0].code) {
            toast.error(error.data.errors[0].message)
            return
          }
        } else {
          if (error.data && typeof error.data === 'object') {
            Object.entries(error.data).forEach(([field, messages]) => {
              toast.error(messages.join('\r\n'), 'Erro:')
            })
          }
          return
        }
      }

      if (error instanceof CustomError) {
        toast[error.level](error.message.replace(/\r\n/g, '<br />'), error.title)
        return
      }

      toast.error(this.$lang.Common.MicroserviceUnavailable)
    },
    /**
     * This function renders on error toaster a backend thrown and translated exception. Returns void.
     * @param err - error object
     */
    onExceptionRendeErrorMessageOnToaster (err) {
      let errorMessagesList = []
      err.data.errors.forEach(singleError => {
        errorMessagesList.push(singleError.message)
      })
      errorMessagesList.forEach(errMessage => {
        if (errMessage === 'Unauthorized' || errMessage === 'ExpiredToken' || errMessage === 'Cannot read properties of undefined (reading \'status\')') {
          toast.error(this.$lang.Common.SessionEnded)
        } else if (errMessage === 'File exceeds allowed bytes size.') {
          let fullError = '<strong>Erro</strong><br>' + this.$lang.Exceptions.FileExceedsBytesSizeException + '<br>Arquivo deve ser menor que 5mb.'
          toast.error(fullError)
        } else if (errMessage === 'Unsupported file extension.') {
          let fullError = '<strong>Erro</strong><br>' + this.$lang.Exceptions.UnsuportedFileFormatException + '<br>Arquivo deve ser .png, .jpg ou .jpeg.'
          toast.error(fullError)
        } else if (errMessage === 'Este quadro já possui uma oportunidade para essa pessoa OU não permite várias oportunidades à mesma pessoa') {
          let fullError = '<strong>Erro</strong><br>Este quadro já possui uma oportunidade para essa pessoa OU não permite várias oportunidades à mesma pessoa'
          toast.error(fullError)
        } else {
          toast.error(errMessage)
        }
      })
      loading.pop()
    },
    /**
     * This function renders on error toaster a custom message. Returns void.
     * @param errMessage - string
     */
    onExceptionRenderMessageOnToaster (errMessage) {
      toast.error(errMessage)
      loading.pop()
    },
    onResultDropdown (response, hasOpt, serializer) {
      var result = []
      // if (response.data.code >= 0) {
      var data = response.data.content
      for (var i in data) {
        // if (data[i].status) {
        if (serializer) {
          result.push({ 'text': serializer(data[i]), 'value': data[i].id })
        } else if (hasOpt) {
          result.push({ 'text': ' ' + data[i].nome, 'value': data[i].id })
        } else {
          result.push({ 'text': data[i].nome, 'value': data[i].id })
        }
        /*
        } else {
          result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
        }
        */
      }
      /*
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      */
      loading.pop()

      return result
    },
    onSetDropdown (data, hasOpt) {
      var result = []

      if (data && data.length > 0) {
        for (var i in data) {
          if (data[i].status) {
            if (hasOpt) {
              result.push({ 'text': ' &nbsp;&nbsp; ' + data[i].nome, 'value': data[i].id })
            } else {
              result.push({ 'text': data[i].nome, 'value': data[i].id })
            }
          } else {
            result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
          }
        }
      }

      return result
    },
    onResultSelect2 (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    onResultAutoComplete (response) {
      var result = []
      if (response.data.code >= 0) {
        var data = response.data.data
        for (var i in data) {
          if (data[i].alias) {
            result.push({ 'text': data[i].alias, 'value': data[i] })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i] })
          }
        }
      } else {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      }
      loading.pop()

      return result
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    getIp () {
      ipify.ipv4()
        .then((ipv4) => {
          this.ip = ipv4
        })
        .catch(err => console.log(err))
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.setPosition)
      }
    },
    setPosition (position) {
      if (position) {
        this.latitude = position.coords.latitude
        this.longitude = position.coords.longitude
      }
    },

    /**
     * Valida os campos obrigatórios do formulário.
     * @param {Array} camposObrigatorios - Array com objetos chave valor {name,message} contendo os nomes dos campos obrigatórios.
     * @throws {CustomError} - Erro com a mensagem de campos faltando.
     */
    validarCamposObrigatorios (camposObrigatorios) {
      let camposFaltando = []
      camposObrigatorios.forEach((campo) => {
        if (!this.dataForm[campo.name]) {
          camposFaltando.push(campo.message)
        }
      })
      if (camposFaltando.length > 0) {
        throw new CustomError(
          `Falta preencher os seguintes campos obrigatórios:\r\n
          ${camposFaltando.map(campo => ` * ${campo}`).join('\r\n')}`,
          {
            cause: 'required_fields',
            level: 'error'
          }
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/actionsForm.js